/* Preventa: cuenta regresiva, galeria de la ficha, barra de compra pegajosa y entrada suave.
   Sale de Prototipos/preventa.html (v3). Cada tarjeta / ficha lleva [data-pv-raiz]; si trae
   data-pv-fin (fecha ISO con hora de Chile), su cuenta regresiva cierra solo esa pieza.
   "?cerrada" en la direccion simula que ya paso la fecha (sirve para ver el estado cerrado). */
(function () {
  'use strict';
  if (window.__pvListo) return;
  window.__pvListo = true;

  var raices = Array.prototype.slice.call(document.querySelectorAll('[data-pv-raiz]'));
  if (!raices.length) return;
  var simularCerrada = /[?&]cerrada(&|=|$)/.test(location.search);
  var timer;

  function dos(n) { return n < 10 ? '0' + n : String(n); }

  function cerrar(raiz) {
    if (raiz.classList.contains('is-pv-cerrada') && !raiz.hasAttribute('data-pv-fin')) return;
    raiz.classList.add('is-pv-cerrada');
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-pv-cuenta]'), function (r) {
      r.classList.add('is-cerrada');
      var c = r.querySelector('.pv-cuenta__cerrada');
      if (c) c.hidden = false;
    });
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-pv-reservar]'), function (b) {
      b.classList.add('is-cerrada');
      b.setAttribute('aria-disabled', 'true');
      b.removeAttribute('href');
      if (b.tagName === 'BUTTON') b.disabled = true;
      var t = b.querySelector('span') || b;
      t.textContent = 'Preventa cerrada';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pv-fija]'), function (f) { f.hidden = true; });
    raiz.removeAttribute('data-pv-fin');
  }

  function tick() {
    var quedan = 0;
    raices.forEach(function (raiz) {
      var fin = raiz.getAttribute('data-pv-fin');
      if (!fin) return;
      var ms = simularCerrada ? 0 : new Date(fin).getTime() - Date.now();
      if (isNaN(ms)) return;
      if (ms <= 0) { cerrar(raiz); return; }
      quedan++;
      var s = Math.floor(ms / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-pv-cuenta]'), function (r) {
        ['d', 'h', 'm', 's'].forEach(function (k) {
          var el = r.querySelector('[data-pv="' + k + '"]');
          if (el) el.textContent = k === 'd' ? v[k] : dos(v[k]);
        });
      });
    });
    if (!quedan && timer) { clearInterval(timer); timer = null; }
  }
  tick();
  timer = setInterval(tick, 1000);

  /* Los botones cerrados no navegan */
  Array.prototype.forEach.call(document.querySelectorAll('[data-pv-reservar]'), function (b) {
    b.addEventListener('click', function (e) { if (b.getAttribute('aria-disabled') === 'true' && b.tagName === 'A') e.preventDefault(); });
  });

  /* Entrada suave al hacer scroll: solo si hay IntersectionObserver y no piden "reducir movimiento" */
  var rev = document.querySelectorAll('.pv-rev');
  var quiereMovimiento = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (rev.length && quiereMovimiento && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pv-js');
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (it) { if (it.isIntersecting) { it.target.classList.add('is-in'); io.unobserve(it.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(rev, function (el) { io.observe(el); });
  }

  /* Galeria: la miniatura cambia la foto grande (sin carrusel) */
  Array.prototype.forEach.call(document.querySelectorAll('[data-pv-galeria]'), function (g) {
    var grande = g.querySelector('.pv-principal') || g.querySelector('.pv-foto__marco img');
    var minis = g.querySelectorAll('.pv-mini');
    if (!grande) return;
    Array.prototype.forEach.call(minis, function (m) {
      m.addEventListener('click', function () {
        grande.hidden = false;
        grande.removeAttribute('srcset');
        grande.src = m.getAttribute('data-src');
        grande.alt = m.getAttribute('data-alt') || '';
        Array.prototype.forEach.call(minis, function (o) { o.removeAttribute('aria-current'); });
        m.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Barra pegajosa (celular): solo se muestra si el boton principal no esta a la vista */
  var fija = document.querySelector('[data-pv-fija]');
  var principal = document.querySelector('[data-pv-boton-principal]');
  if (fija && principal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (items) {
      if (items[0].isIntersecting) fija.setAttribute('inert', ''); else fija.removeAttribute('inert');
    }).observe(principal);
  }
  if (fija) {
    Array.prototype.forEach.call(fija.querySelectorAll('[data-pv-ir]'), function (a) {
      a.addEventListener('click', function (e) {
        if (a.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        var destino = principal;
        if (destino) { e.preventDefault(); destino.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
  }
})();
